import { TrainingLocationTypeModel } from "../models/training/training-location-type.model";
import { TrainingLocationModel } from "../models/training/training-location.model";

export function getTrainingLocationLabel(trainingLocation: TrainingLocationModel): string {
  switch (trainingLocation.type) {
    case TrainingLocationTypeModel.Web:
      return 'Web Webinar';

    case TrainingLocationTypeModel.Webex:
      return 'Webex Webinar';

    case TrainingLocationTypeModel.Webinar:
      return 'Webinar';

    case TrainingLocationTypeModel.Zoom:
      return 'Zoom Webinar';

    case TrainingLocationTypeModel.GotoMeeting:
      return 'GoToMeeting Webinar';

    case TrainingLocationTypeModel.MsTeamsWebinar:
      return 'Microsoft Teams Webinar';

    case TrainingLocationTypeModel.MsTeamsMeetings:
      return 'Microsoft Teams Meeting';

    case TrainingLocationTypeModel.GoToWebinar:
      return 'GoToWebinar Webinar';

    case TrainingLocationTypeModel.Address:
      return trainingLocation.location || 'n.a.';

    default:
      return 'n.a.';
  }
}